// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1rM8a","error":"Textarea_error__2XLNx","readonly":"Textarea_readonly__1QCSq","disabled":"Textarea_disabled__6JkWv"};